import React, { useEffect, useState } from "react";
import Collapsible from "react-collapsible";
import TextInputNolabel from "../../../ShareElements/TextInput/TextInputNolabel";
import TextAreaNolabel from "../../../ShareElements/TextInput/TextAreaNolabel";
import MultiSelect from "./MultiSelect";
import Datepicker from "./DatePicker";
import axios from "axios";
import { Config } from "../../../../../../Config";
import SearchSelect from "./SearchSelect";
import SingleSlider from "./SingleSlider";
import Rotator from "../../../../../../Assets/Images/ButtonLoadingIcon.svg";
import IconSwitch from "../../../ShareElements/Switch/IconSwitch";
import {
  displayAvailabilityDateUnitNameText,
  formatDate,
} from "../../../../../../Helper_functions";
import AvailabilityIcon from "../../../../../../Assets/Images/more_time.svg";
import AvalilabilityDatepicker from "../../../ShareElements/AvailabilityDatepicker/AvailabilityDatepicker";

const CandidatesHead = (props) => {
  const [IsOpen, setIsOpen] = useState(false);
  const [ShowMoreIsOpen, setShowMoreIsOpen] = useState(false);
  const [EditIsActive, setEditIsActive] = useState(false);
  const [StartDateIsOpen, setStartDateIsOpen] = useState(false);
  const [EndDateIsOpen, setEndDateIsOpen] = useState(false);
  const [SelectedStartDate, setSelectedStartDate] = useState("");
  const [SelectedEndDate, setSelectedEndDate] = useState("");
  const [Languages, setLanguages] = useState([]);
  const [Locations, setLocations] = useState([]);
  const [Educations, setEducationOptions] = useState([]);
  const [Skills, setSkills] = useState([]);
  const [SelectedSkills, setSelectedSkills] = useState([]);
  const [PreselectedSkills, setPreselectedSkills] = useState([]);
  const [SelectedEducation, setSelectedEducation] = useState([]);
  const [SelectedLocations, setSelectedLocations] = useState(
    props.JPA.workCity ? [props.JPA.workCity] : []
  );
  const [SelectedLangs, setSelectedLangs] = useState(props.JPA.languages || []);
  const [SkillsModalIsOpen, setSkillsModalIsOpen] = useState(false);
  const [LanguagesModalIsOpen, setLanguagesModalIsOpen] = useState(false);
  const [LocationsModalIsOpen, setLocationModalIsOpen] = useState(false);
  const [EducationsModalIsOpen, setEducationModalIsOpen] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchAllLanguages();
    fetchEducations();
    fetchLocations();
    fetchSkills();
    setPreselectedSkills(props.JPA.skills);
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const savePreSelectedEducations = () => {
    let Selected = [];
    Educations.map((Ed) => {
      if (
        document
          .getElementById("icon-" + Ed.id)
          .classList.contains("feather-check-selected")
      ) {
        Selected.push(Ed.name);
      }
    });
    setSelectedEducation(Selected);
  };

  const handleOpen = () => {
    setIsOpen(true);
    document.getElementById("collapsible-trigger").classList.add("rotated");
    document.querySelectorAll(
      ".big-collapsible .Collapsible__contentOuter"
    )[0].style.overflow = "visible";
  };
  const handleClose = () => {
    setEditIsActive(false);
    setIsOpen(false);
    document.getElementById("collapsible-trigger").classList.remove("rotated");
    document.querySelectorAll(
      ".big-collapsible .Collapsible__contentOuter"
    )[0].style.overflow = "hidden";
  };
  const fetchAllLanguages = () => {
    let ReqURL;
    if (props.IsJob) {
      ReqURL =
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/preset/find-all-languages";
    } else if (props.IsProject) {
      ReqURL =
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/preset/find-all-languages";
    } else if (props.IsActivity) {
      ReqURL =
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/preset/find-all-languages";
    }
    let Req = {
      method: "GET",
      baseURL: ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        let Langs = [];
        Res.data.map((Lang) => {
          Langs.push({
            name: Lang.name,
            id: Lang.id,
          });
        });
        setLanguages(Langs);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const fetchEducations = () => {
    let ReqURL;
    if (props.IsJob) {
      ReqURL =
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/preset/find-all-educations";
    } else if (props.IsProject) {
      ReqURL =
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/preset/find-all-educations";
    } else if (props.IsActivity) {
      ReqURL =
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/preset/find-all-educations";
    }
    let Req = {
      method: "GET",
      baseURL: ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        let Educations = [];
        Res.data.map((EdItem) => {
          if (EdItem !== "") {
            Educations.push({
              name: EdItem,
              id: EdItem.replace(" ", "_")
                .replace(" ", "_")
                .replace(" ", "_")
                .replace(" ", "_")
                .replace(" ", "_")
                .replace(" ", "_"),
            });
          }
        });
        setEducationOptions(Educations);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const fetchLocations = () => {
    let ReqURL;
    if (props.IsJob) {
      ReqURL =
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/preset/find-all-cities";
    } else if (props.IsProject) {
      ReqURL =
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/preset/find-all-cities";
    } else if (props.IsActivity) {
      ReqURL =
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/preset/find-all-cities";
    }
    let Req = {
      method: "GET",
      baseURL: ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        let Locations = [];
        Res.data.map((Item) => {
          Locations.push({
            name: Item,
            id:
              "location-" +
              Item.replace(" ", "_")
                .replace(" ", "_")
                .replace(" ", "_")
                .replace(" ", "_")
                .replace(" ", "_")
                .replace(" ", "_")
                .replace(" ", "_"),
          });
        });
        setLocations(Locations);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const fetchSkills = (NameLike) => {
    let Keyword = NameLike;
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL + Config.PositionServiceURL + "/api/skill/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        size: 100,
        start: 0,
        criteria: {
          titleLike: Keyword,
        },
        sorts: [
          {
            direction: "ASC",
            fieldName: "title",
          },
        ],
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        // the newArray localStorage item is a variable that stores already checked skill items
        if (localStorage.getItem("newArray")) {
          let AlreadySelected = Array.from(
            new Set(JSON.parse(localStorage.getItem("newArray")))
          );
          let SelectedIDs = [];
          AlreadySelected.map((Item) => {
            SelectedIDs.push(Item.id);
          });

          let NewOptions = [];
          Res.data.results.map((Item) => {
            if (SelectedIDs.indexOf(Item.id) === -1) {
              NewOptions.push(Item);
            }
          });
          setSkills(NewOptions);
        } else {
          setSkills(Res.data.results);
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const updateSkills = (List) => {
    // saving the list of selected skill options
    let Selected = [];
    [...List].map((Item) => {
      if (Selected.indexOf(Item) === -1) {
        Selected.push(Item);
      }
    });
    setSelectedSkills(Selected);

    var RemainingSkills = [];
    [...Skills].map((SkillItem) => {
      if ([...List].indexOf(SkillItem) === -1) {
        RemainingSkills.push(SkillItem);
      }
    });
    setSkills(RemainingSkills);
  };

  const clearSkills = () => {
    removeSkillsSelectedState();
    setSelectedSkills([]);
    fetchSkills("");
  };
  const removeSkillsSelectedState = () => {
    Skills.map((Item) => {
      let Id = Item.id;
      if (document.getElementById(Id + "-option") !== null) {
        document.getElementById(Id + "-option").classList.remove("selected");
      }
    });
  };

  const displayChips = (ItemsToDisplay, Type) => {
    let Items;
    if (typeof ItemsToDisplay === "object") {
      Items = ItemsToDisplay;
    } else {
      Items = ItemsToDisplay.split(",");
    }
    if (ItemsToDisplay !== null) {
      var TotalItems = [];
      Items.map((Item) => {
        Item.name ? TotalItems.push(Item.name) : TotalItems.push(Item.title);
      });
      if (Type === "location" || Type === "educations") {
        TotalItems = ItemsToDisplay.split(",");
      }

      if (window.innerWidth > 450) {
        if (TotalItems.length <= 2) {
          return (
            <div className="chips-wrapper">
              {TotalItems.map((Item) => (
                <span className="small-chip">
                  {Item.length < 10 ? (
                    Item
                  ) : (
                    <React.Fragment>
                      {Item.slice(0, 9) + " ..."}
                      <p className="popup-text">{Item}</p>
                    </React.Fragment>
                  )}
                </span>
              ))}
            </div>
          );
        } else {
          let FirstTwo = [...TotalItems].splice(0, 2);
          return (
            <div className="chips-wrapper">
              {FirstTwo.map((Item) => (
                <span className="small-chip">
                  {Item.length < 10 ? (
                    Item
                  ) : (
                    <React.Fragment>
                      {Item.slice(0, 9) + " ..."}
                      <p className="popup-text">{Item}</p>
                    </React.Fragment>
                  )}
                </span>
              ))}
              {Type === "skills" ? (
                <button
                  className="more-btn"
                  onClick={() => setSkillsModalIsOpen(true)}
                >
                  <i className="feather-more-horizontal"></i>
                </button>
              ) : (
                <React.Fragment>
                  {Type === "languages" ? (
                    <button
                      className="more-btn"
                      onClick={() => setLanguagesModalIsOpen(true)}
                    >
                      <i className="feather-more-horizontal"></i>
                    </button>
                  ) : (
                    <React.Fragment>
                      {Type === "location" ? (
                        <button
                          className="more-btn"
                          onClick={() => setLocationModalIsOpen(true)}
                        >
                          <i className="feather-more-horizontal"></i>
                        </button>
                      ) : (
                        <button
                          className="more-btn"
                          onClick={() => setEducationModalIsOpen(true)}
                        >
                          <i className="feather-more-horizontal"></i>
                        </button>
                      )}
                    </React.Fragment>
                  )}
                </React.Fragment>
              )}
            </div>
          );
        }
      } else {
        if (TotalItems.length <= 1) {
          return (
            <div className="chips-wrapper">
              {TotalItems.map((Item) => (
                <span className="small-chip">
                  {Item.length <= 9 ? Item : Item.slice(0, 6) + " ..."}
                </span>
              ))}
            </div>
          );
        } else {
          let FirstItem = [...TotalItems].splice(0, 1);
          return (
            <div className="chips-wrapper">
              <span className="small-chip">
                {FirstItem[0].length <= 9
                  ? FirstItem
                  : FirstItem[0].slice(0, 6) + " ..."}
              </span>
              {Type === "skills" ? (
                <button
                  className="more-btn"
                  onClick={() => setSkillsModalIsOpen(true)}
                >
                  <i className="feather-more-horizontal"></i>
                </button>
              ) : (
                <React.Fragment>
                  {Type === "languages" ? (
                    <button
                      className="more-btn"
                      onClick={() => setLanguagesModalIsOpen(true)}
                    >
                      <i className="feather-more-horizontal"></i>
                    </button>
                  ) : (
                    <button
                      className="more-btn"
                      onClick={() => setEducationModalIsOpen(true)}
                    >
                      <i className="feather-more-horizontal"></i>
                    </button>
                  )}
                </React.Fragment>
              )}
            </div>
          );
        }
      }
    }
  };
  const saveStartDate = (StartDate) => {
    setSelectedStartDate(StartDate);
    setStartDateIsOpen(false);
  };
  const saveEndDate = (EndDate) => {
    setSelectedEndDate(EndDate);
    setEndDateIsOpen(false);
    document.getElementById("date-validation-message").style.display = "none";
  };
  const shortenDesc = (Desc) => {
    if (Desc.length <= 128) {
      return <p className="description-text">{Desc}</p>;
    } else {
      return (
        <React.Fragment>
          {ShowMoreIsOpen ? null : (
            <p className="description-text">
              {Desc.slice(0, 128)}
              {" ..."}
            </p>
          )}
          <Collapsible
            trigger={
              <React.Fragment>
                {ShowMoreIsOpen ? (
                  <p className="show-more is-open">
                    Show less <i className="feather-chevron-up"></i>
                  </p>
                ) : (
                  <p className="show-more">
                    Show more <i className="feather-chevron-down"></i>
                  </p>
                )}
              </React.Fragment>
            }
            onOpen={() => setShowMoreIsOpen(true)}
            onClose={() => setShowMoreIsOpen(false)}
            transitionTime={200}
          >
            <p className="description-text">{Desc}</p>
          </Collapsible>
        </React.Fragment>
      );
    }
  };

  // **How the save Process works**
  // there are 4 main functions involved that are called respectively as below:
  // 1) createJPAdata() that creates the main data i.e. CoreInfo and RecommendationCriteria
  // 2) validateEditData(CoreInfo, RecommendationCriteria) receives the data and validates them
  // 3) togglePublish(CoreInfo, RecommendationCriteria) is called when the validation has passed, after this
  //    function is done, the publish state has been edited and we call the next function to edit the Core data and criteria
  // 4) EditJPA(CoreInfo, RecommendationCriteria) saves the validated data and updates the data by calling the functions in the parent
  const startSaveProcess = () => {
    createJPAdata();
  };
  const togglePublish = (CoreInfo, RecommendationCriteria) => {
    let Action;
    if (
      document
        .getElementById("jpa-publish-icon-switch")
        .classList.contains("icon-switch-wrapper-active")
    ) {
      Action = "PUBLISH";
    } else {
      Action = "UNPUBLISH";
    }
    let ReqURL;
    let Id;
    if (props.IsJob) {
      ReqURL =
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/preset/publish-unpublish";
      Id = props.JPA.id;
    } else if (props.IsProject) {
      ReqURL =
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/preset/publish-unpublish";
      Id = props.JPA.id;
    } else if (props.IsActivity) {
      ReqURL =
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/preset/publish-unpublish";
      Id = props.JPA.id;
    }
    let Req = {
      method: "POST",
      baseURL: ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        id: Id,
        action: Action,
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        EditJPA(CoreInfo, RecommendationCriteria);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const createJPAdata = () => {
    let CoreInfo = {
      id: props.JPA.id,
      title: document.getElementById("title").value,
      description: document.getElementById("description").value,
    };
    // Resource availability data
    if (document.getElementById("value").value.length > 0) {
      CoreInfo.availabilityValue = document.getElementById("value").value;
      CoreInfo.availabilityUnit =
        document.getElementById("avalability-filter").value;
    }

    if (SelectedStartDate === "") {
      CoreInfo.startDate = props.JPA.startDate;
    } else {
      CoreInfo.startDate = new Date(SelectedStartDate).toISOString();
    }
    if (SelectedEndDate === "") {
      CoreInfo.endDate = props.JPA.endDate;
    } else {
      CoreInfo.endDate = new Date(SelectedEndDate).toISOString();
    }
    let SkillIds = [];
    let SkillsArray = [];
    if (SelectedSkills.length === 0) {
      SkillsArray = props.JPA.skills;
    } else {
      SkillsArray = SelectedSkills;
    }

    SkillsArray.map((Skill) => {
      SkillIds.push(Skill.id);
    });

    let LocationNames = [];
    if (SelectedLocations.length !== 0) {
      SelectedLocations.map((Loc) => {
        const CityName = Loc.id ? Loc.name : Loc;
        LocationNames.push(CityName);
      });
    }

    let LangIds = [];
    if (SelectedLangs.length !== 0) {
      SelectedLangs.map((Lang) => {
        LangIds.push(Lang.id);
      });
    }

    let RecommendationCriteria = {
      cities: LocationNames,
      languageIds: LangIds,
      skillIds: [...SkillIds],
      yearsOfExperience: parseInt(
        document.getElementById("yoe-single").innerHTML
      ),
      educations: SelectedEducation,
    };
    if (props.IsJob) {
      RecommendationCriteria.positionId = props.JPA.id;
    } else if (props.IsProject) {
      RecommendationCriteria.projectId = props.JPA.id;
    } else if (props.IsActivity) {
      RecommendationCriteria.activityId = props.JPA.id;
    }

    validateEditData(CoreInfo, RecommendationCriteria);
  };
  const validateEditData = (CoreInfo, RecommendationCriteria) => {
    titleIsOk(CoreInfo.title);
    dateIsOk(CoreInfo.startDate, CoreInfo.endDate);
    skillsAreOk();
    if (
      !titleIsOk(CoreInfo.title) ||
      !dateIsOk(CoreInfo.startDate, CoreInfo.endDate) ||
      !skillsAreOk()
    ) {
      setIsLoading(false);
    } else {
      setIsLoading(true);
      togglePublish(CoreInfo, RecommendationCriteria);
    }
  };
  const titleIsOk = (Title) => {
    if (Title.length === 0) {
      document.getElementById("title-label-holder").classList.add("wrong");
      return false;
    } else {
      return true;
    }
  };
  const dateIsOk = (Start, End) => {
    if (End !== null) {
      let StartDate = new Date(Start).getTime();
      let EndDate = new Date(End).getTime();
      let Difference = parseInt(StartDate - EndDate);
      if (Difference > 0) {
        document.getElementById("date-validation-message").style.display =
          "block";
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  };
  const removeTitleErrorState = () => {
    document.getElementById("title-label-holder").classList.remove("wrong");
  };
  const locationIsOk = () => {
    let SelectedItems = [];
    Locations.map((Loc) => {
      let Name = Loc.name
        .replace(" ", "_")
        .replace(" ", "_")
        .replace(" ", "_")
        .replace(" ", "_")
        .replace(" ", "_")
        .replace(" ", "_");
      if (
        document
          .getElementById("icon-location-" + Name)
          .classList.contains("feather-check-selected")
      ) {
        SelectedItems.push(Loc);
      }
    });
    if (SelectedItems.length > 0) {
      if (SelectedItems.length > 0) {
        return true;
      } else {
        document
          .getElementById("location-select")
          .classList.add("multi-select-error-state");
        return false;
      }
    } else {
      document
        .getElementById("location-select")
        .classList.add("multi-select-error-state");
      return false;
    }
  };
  const LanuageIsOk = () => {
    let SelectedItems = [];
    Languages.map((Lang) => {
      if (
        document
          .getElementById("icon-" + Lang.id)
          .classList.contains("feather-check-selected")
      ) {
        SelectedItems.push(Lang);
      }
    });
    if (SelectedItems.length <= 0) {
      document
        .getElementById("language-select")
        .classList.add("multi-select-error-state");
      return false;
    } else {
      return true;
    }
  };
  const removeMultiSelectErrorState = (Id) => {
    document.getElementById(Id).classList.remove("multi-select-error-state");
  };
  const skillsAreOk = () => {
    let SkillsCount = document
      .getElementById("search-select-selected-count")
      .innerHTML.replace(/[^0-9]/g, ""); // the replace method with this parameter replaces all non-number characters with "" and gets the count of selected items
    if (SkillsCount < 5) {
      document
        .getElementById("search-select-wrapper")
        .classList.add("error-shown");
      return false;
    } else {
      return true;
    }
  };
  const EditJPA = (CoreInfo, RecommendationCriteria) => {
    let EditCoreURL;
    let SaveCriteriaURL;

    if (props.IsJob) {
      EditCoreURL =
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/preset/update-core-info";
      SaveCriteriaURL =
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/preset/save-recommendation-criteria";
    } else if (props.IsProject) {
      EditCoreURL =
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/preset/update-core-info";
      SaveCriteriaURL =
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/preset/save-recommendation-criteria";
    } else if (props.IsActivity) {
      EditCoreURL =
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/preset/update-core-info";
      SaveCriteriaURL =
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/preset/save-recommendation-criteria";
    }
    let ReqCore = {
      method: "POST",
      baseURL: EditCoreURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: CoreInfo,
    };
    axios(ReqCore).then((Res) => {
      console.log(Res);
      let ReqCriteria = {
        method: "POST",
        baseURL: SaveCriteriaURL,
        headers: {
          Authorization: "Bearer " + window.localStorage.getItem("Token"),
        },
        data: RecommendationCriteria,
      };
      axios(ReqCriteria)
        .then((Res) => {
          console.log(Res);
          setIsLoading(false);
          setEditIsActive(false);
          setTimeout(() => {
            props.UpdateJPA();
            props.UpdateCandidates();
          }, 300);
        })
        .catch((Err) => {
          console.log(Err.response);
          setIsLoading(false);
        });
    });
  };
  const saveEducation = (SelectedEds) => {
    let Selected = [];
    SelectedEds.map((Ed) => {
      Selected.push(Ed.name);
    });
    setSelectedEducation(Selected);
  };
  const handlePreselectedEducations = () => {
    // props.JPA.education can return empty string, therefore we check if the value is truthy
    if (props.JPA.education !== null && Boolean(props.JPA.education)) {
      let Selected = props.JPA.education.split(",");
      let SelectedWithIds = [];
      Selected.map((Item) => {
        SelectedWithIds.push({
          name: Item,
          id: Item.replace(" ", "_")
            .replace(" ", "_")
            .replace(" ", "_")
            .replace(" ", "_")
            .replace(" ", "_")
            .replace(" ", "_"),
        });
      });
      return SelectedWithIds;
    }
  };
  const toggleEdit = () => {
    setEditIsActive(true);
    setTimeout(() => {
      savePreSelectedEducations();
    }, 400);
  };
  const saveSelectedLocations = (Selected) => {
    setSelectedLocations(Selected);
  };
  const saveSelectedLangs = (Selected) => {
    setSelectedLangs(Selected);
  };
  const displaySkills = () => {
    let ParentArray = [];
    props.JPA.skills.map((Item) => {
      ParentArray.push(Item);
    });
    let Skills = [...ParentArray];
    let Top10 = [...ParentArray].splice(0, 10);
    let OtherSkills = [...ParentArray].splice(10, Skills.length);
    return (
      <section className="all-skills">
        {Top10.map((Skill) => (
          <React.Fragment>
            <div className="skill-item">{Skill.title}</div>
          </React.Fragment>
        ))}
        {props.JPA.skills.length > 10 ? (
          <p
            className="view-all"
            id="view-all-btn"
            onClick={() => handleTrigger()}
          >
            {/* {translateText("view_all")}  */}View all
            <i className="feather-chevron-down"></i>
          </p>
        ) : null}
        <Collapsible
          transitionTime={200}
          trigger={<p id="view-all" hidden></p>}
        >
          <React.Fragment>
            {OtherSkills.map((Skill) => (
              <div className="skill-item">{Skill}</div>
            ))}
          </React.Fragment>
        </Collapsible>
      </section>
    );
  };
  const displayLanguages = () => {
    let ParentArray = [];
    props.JPA.languages.map((Item) => {
      ParentArray.push(Item);
    });
    let Languages = [...ParentArray];
    let Top10 = [...ParentArray].splice(0, 10);
    let OtherLanguages = [...ParentArray].splice(10, Languages.length);
    return (
      <section className="all-skills">
        {Top10.map((Lang) => (
          <React.Fragment>
            <div className="skill-item">{Lang.name}</div>
          </React.Fragment>
        ))}
        {props.JPA.skills.length > 10 ? (
          <p
            className="view-all"
            id="view-all-btn"
            onClick={() => handleTrigger()}
          >
            {translateText("view_all")}
            <i className="feather-chevron-down"></i>
          </p>
        ) : null}
        <Collapsible
          transitionTime={200}
          trigger={<p id="view-all" hidden></p>}
        >
          <React.Fragment>
            {OtherLanguages.map((Lang) => (
              <div className="skill-item">{Lang}</div>
            ))}
          </React.Fragment>
        </Collapsible>
      </section>
    );
  };
  const displayEducations = () => {
    let ParentArray = [];
    props.JPA.education.split(",").map((Item) => {
      ParentArray.push(Item);
    });
    let Educations = [...ParentArray];
    let Top10 = [...ParentArray].splice(0, 10);
    let OtherEducations = [...ParentArray].splice(10, Educations.length);
    return (
      <section className="all-skills">
        {Top10.map((Ed) => (
          <React.Fragment>
            <div className="skill-item">{Ed}</div>
          </React.Fragment>
        ))}
        {props.JPA.skills.length > 10 ? (
          <p
            className="view-all"
            id="view-all-btn"
            onClick={() => handleTrigger()}
          >
            {translateText("view_all")}
            <i className="feather-chevron-down"></i>
          </p>
        ) : null}
        <Collapsible
          transitionTime={200}
          trigger={<p id="view-all" hidden></p>}
        >
          <React.Fragment>
            {OtherEducations.map((Ed) => (
              <div className="skill-item">{Ed}</div>
            ))}
          </React.Fragment>
        </Collapsible>
      </section>
    );
  };
  const displayLocations = () => {
    let ParentArray = [];
    props.JPA.workCity.split(",").map((Item) => {
      ParentArray.push(Item);
    });
    let Locations = [...ParentArray];
    let Top10 = [...ParentArray].splice(0, 10);
    let OtherLocations = [...ParentArray].splice(10, Locations.length);
    return (
      <section className="all-skills">
        {Top10.map((Loc) => (
          <React.Fragment>
            <div className="skill-item">{Loc}</div>
          </React.Fragment>
        ))}
        {props.JPA.workCity.split(",").length > 10 ? (
          <p
            className="view-all"
            id="view-all-btn"
            onClick={() => handleTrigger()}
          >
            {translateText("view_all")}
            <i className="feather-chevron-down"></i>
          </p>
        ) : null}
        <Collapsible
          transitionTime={200}
          trigger={<p id="view-all" hidden></p>}
        >
          <React.Fragment>
            {OtherLocations.map((Loc) => (
              <div className="skill-item">{Loc}</div>
            ))}
          </React.Fragment>
        </Collapsible>
      </section>
    );
  };
  const handleTrigger = () => {
    document.getElementById("view-all").click();
    document.getElementById("view-all-btn").style.display = "none";
  };
  const shortenTitle = (JPATitle) => {
    if (JPATitle.length < 60) {
      return JPATitle;
    } else {
      let Short = JPATitle.slice(0, 56) + " ...";
      return Short;
    }
  };
  const downloadExcel = () => {
    let URL = window._env_.API_URL;

    if (props.IsJob) {
      URL =
        URL +
        Config.PositionServiceURL +
        "/api" +
        "/position" +
        "/preset/" +
        props.JPA.id +
        "/candidates/export";
    } else if (props.IsProject) {
      URL =
        URL +
        Config.ProjectServiceURL +
        "/api" +
        "/project" +
        "/preset/" +
        props.JPA.id +
        "/candidates/export";
    } else {
      URL =
        URL +
        Config.ActivityServiceURL +
        "/api" +
        "/activity" +
        "/preset/" +
        props.JPA.id +
        "/candidates/export";
    }

    let Req = {
      method: "GET",
      responseType: "blob",
      baseURL: URL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        let URL = window.URL.createObjectURL(new Blob([Res.data]));
        let Link = document.createElement("a");
        Link.href = URL;
        Link.setAttribute(
          "download",
          "Recommended_candidates_" +
            props.JPA.title.replace(/\s/g, "") +
            ".xlsx"
        );
        document.body.appendChild(Link);
        Link.click();
        setTimeout(() => {
          document.body.removeChild(Link);
        }, 500);
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  return (
    <div className="jpa-candidates-head">
      {SkillsModalIsOpen ? (
        <div className="skills-modal-overlay">
          <div
            className="outline"
            onClick={() => setSkillsModalIsOpen(false)}
          ></div>
          <div className="modal-body">
            <section className="modal-head">
              <p className="job-title">{props.JPA.title}</p>
              <i
                className="feather-x"
                onClick={() => setSkillsModalIsOpen(false)}
              ></i>
            </section>
            <section className="modal-content">
              <h1 className="content-title">{translateText("top_5_skills")}</h1>

              {displaySkills()}
            </section>
          </div>
        </div>
      ) : null}
      {LocationsModalIsOpen ? (
        <div className="skills-modal-overlay">
          <div
            className="outline"
            onClick={() => setLocationModalIsOpen(false)}
          ></div>
          <div className="modal-body">
            <section className="modal-head">
              <p className="job-title">{props.JPA.title}</p>
              <i
                className="feather-x"
                onClick={() => setLocationModalIsOpen(false)}
              ></i>
            </section>
            <section className="modal-content">
              <h1 className="content-title">{translateText("location")}</h1>

              {displayLocations()}
            </section>
          </div>
        </div>
      ) : null}
      {LanguagesModalIsOpen ? (
        <div className="skills-modal-overlay">
          <div
            className="outline"
            onClick={() => setLanguagesModalIsOpen(false)}
          ></div>
          <div className="modal-body">
            <section className="modal-head">
              <p className="job-title">{props.JPA.title}</p>
              <i
                className="feather-x"
                onClick={() => setLanguagesModalIsOpen(false)}
              ></i>
            </section>
            <section className="modal-content">
              <h1 className="content-title">{translateText("languages")}</h1>

              {displayLanguages()}
            </section>
          </div>
        </div>
      ) : null}
      {EducationsModalIsOpen ? (
        <div className="skills-modal-overlay">
          <div
            className="outline"
            onClick={() => setEducationModalIsOpen(false)}
          ></div>
          <div className="modal-body">
            <section className="modal-head">
              <p className="job-title">{props.JPA.title}</p>
              <i
                className="feather-x"
                onClick={() => setEducationModalIsOpen(false)}
              ></i>
            </section>
            <section className="modal-content">
              <h1 className="content-title">{translateText("education")}</h1>

              {displayEducations()}
            </section>
          </div>
        </div>
      ) : null}
      <section className="header-top">
        <i className="feather-arrow-left" onClick={() => props.GoBack()}></i>
        <h1>{translateText("candidates")}</h1>
        {window.innerWidth > 450 ? (
          <span className="export-btn" onClick={() => downloadExcel()}>
            <i className="feather-download"></i>
            {translateText("export_data_to_excel")}
          </span>
        ) : (
          <span className="export-btn" onClick={() => downloadExcel()}>
            <i className="feather-download"></i>
            {translateText("export")}
          </span>
        )}
      </section>
      <div className="big-collapsible">
        <Collapsible
          trigger={
            <section className="header-toggle">
              {!EditIsActive ? (
                <>
                  <p>{shortenTitle(props.JPA.title)}</p>
                  {IsOpen && !EditIsActive ? (
                    <>
                      {props.JPA.published ? (
                        <span className="publish-status published">
                          {translateText("published")}
                        </span>
                      ) : (
                        <span className="publish-status unpublished">
                          {translateText("unpublished")}
                        </span>
                      )}
                    </>
                  ) : null}
                </>
              ) : null}
              <span id="collapsible-trigger">
                <i className="feather-chevron-down"></i>
              </span>
            </section>
          }
          transitionTime={200}
          onOpen={() => handleOpen()}
          onClose={() => handleClose()}
        >
          <div
            className={
              IsOpen && EditIsActive
                ? "header-collapsible header-collapsible-open"
                : "header-collapsible"
            }
          >
            {IsOpen && !EditIsActive ? (
              <span className="edit-btn" onClick={() => toggleEdit()}>
                <i className="feather-edit-2"></i>
                {window.innerWidth > 450 ? translateText("edit") : null}
              </span>
            ) : (
              <React.Fragment>
                {IsOpen ? (
                  <section className="edit-form-actions">
                    <span
                      className="secondary-action"
                      onClick={() => setEditIsActive(false)}
                    >
                      {translateText("cancel")}
                    </span>
                    {IsLoading ? (
                      <span
                        className="primary-action disabled-action"
                        onClick={() => startSaveProcess()}
                      >
                        <img alt="" src={Rotator} className="loading-icon" />
                      </span>
                    ) : (
                      <span
                        className="primary-action"
                        onClick={() => startSaveProcess()}
                      >
                        {translateText("save")}
                      </span>
                    )}
                  </section>
                ) : null}
              </React.Fragment>
            )}
            {!EditIsActive ? (
              <React.Fragment>
                {props.JPA.description ? (
                  <section className="description-holder">
                    {shortenDesc(props.JPA.description)}
                  </section>
                ) : null}
                <section className="end-start-dates">
                  <span className="date-item">
                    <i className="feather-calendar"></i>
                    {translateText("start_date")}
                    <p>{formatDate(props.JPA.startDate)}</p>
                  </span>
                  <span className="date-item">
                    <i className="feather-calendar"></i>
                    {translateText("end_date")}
                    {props.JPA.endDate === null ? (
                      <p className="date-unavailable">
                        {translateText("not_available")}
                      </p>
                    ) : (
                      <p>{formatDate(new Date(props.JPA.endDate).getTime())}</p>
                    )}
                  </span>
                  <span className="date-item">
                    <img alt="" src={AvailabilityIcon} />
                    {translateText("availability")}
                    <>
                      {props.JPA.availabilityValue ? (
                        <p className="availability-date">
                          {props.JPA.availabilityValue +
                            " " +
                            displayAvailabilityDateUnitNameText(
                              props.JPA.availabilityUnit,
                              props.LangData
                            )}
                        </p>
                      ) : (
                        <p className="availability-date">
                          {translateText("not_available")}
                        </p>
                      )}
                    </>
                  </span>
                </section>
                <div className="vr-line"></div>
                <section className="criteria-wrapper">
                  <h1 className="section-name">
                    {translateText("recom_criteria")}
                    <i className="feather-alert-circle">
                      <p>{translateText("recom_criteria_info")}</p>
                    </i>
                  </h1>
                  <div className="criteria-items">
                    <section className="criteria-row read-only-row">
                      <p className="row-name yoe">
                        YoE{" "}
                        <p className="popup-text">
                          {translateText("years_of_experience")}
                        </p>
                      </p>
                      <div className="row-content">
                        <p className="simple-text">
                          {props.JPA.yearsOfExperience}
                        </p>
                      </div>
                    </section>
                    <section className="criteria-row read-only-row">
                      <p className="row-name">{translateText("location")}</p>
                      {props.JPA.workCity ? (
                        <div className="row-content">
                          {displayChips(props.JPA.workCity, "location")}
                        </div>
                      ) : null}
                    </section>
                    <section className="criteria-row read-only-row">
                      <p className="row-name">{translateText("language")}</p>
                      <div className="row-content">
                        {displayChips(props.JPA.languages, "languages")}
                      </div>
                    </section>
                    <section className="criteria-row read-only-row">
                      <p className="row-name">
                        {translateText("top_5_skills")}
                      </p>
                      <div className="row-content">
                        {displayChips(props.JPA.skills, "skills")}
                      </div>
                    </section>
                    <section className="criteria-row read-only-row">
                      <p className="row-name">{translateText("education")}</p>
                      {props.JPA.education ? (
                        <div className="row-content">
                          {displayChips(props.JPA.education, "educations")}
                        </div>
                      ) : null}
                    </section>
                  </div>
                </section>
              </React.Fragment>
            ) : (
              <div className="edit-form">
                <section className="edit-form-row">
                  <p className="row-name">{translateText("title")}</p>
                  <TextInputNolabel
                    Name="Title"
                    InitialValue={props.JPA.title}
                    Id="title"
                    ChangeEvent={() => removeTitleErrorState()}
                    ValidationMessage="Please enter the title."
                  />
                </section>
                <section className="edit-form-row">
                  <p className="row-name desc-label">
                    {translateText("description")}
                  </p>
                  <TextAreaNolabel
                    Name="Description"
                    InitialValue={props.JPA.description}
                    Id="description"
                    ChangeEvent={() => null}
                  />
                </section>
                <section className="edit-form-row edit-form-row-datepickers edit-row-items">
                  <div className="datepicker-holder">
                    <span className="trigger-label">
                      <img alt="" src={AvailabilityIcon} />
                      <p> {translateText("availability")}</p>
                    </span>
                    <AvalilabilityDatepicker
                      LangData={props.LangData}
                      HideStartDate
                      HideEndDate
                      InitialValue={props.JPA.availabilityValue}
                      InitialUnit={props.JPA.availabilityUnit}
                    />
                  </div>
                  <div className="datepicker-holder">
                    <span className="trigger-label">
                      <i className="feather-calendar"></i>
                      <p>{translateText("start_date")}</p>
                    </span>
                    <section
                      className="datepicker-trigger"
                      onClick={() => setStartDateIsOpen(true)}
                    >
                      {SelectedStartDate === ""
                        ? formatDate(new Date(props.JPA.startDate))
                        : formatDate(new Date(SelectedStartDate))}
                    </section>
                    {StartDateIsOpen ? (
                      <div className="datepicker">
                        <Datepicker
                          SaveSelectedDate={(StartDate) =>
                            saveStartDate(StartDate)
                          }
                          Close={() => setStartDateIsOpen(false)}
                        />
                      </div>
                    ) : null}
                    {SelectedStartDate === "" ? null : (
                      <i
                        className="feather-x-circle"
                        onClick={() => setSelectedStartDate("")}
                      ></i>
                    )}
                  </div>
                  <div className="datepicker-holder">
                    <span className="trigger-label">
                      <i className="feather-calendar"></i>
                      <p>{translateText("end_date")}</p>
                    </span>
                    <section
                      className="datepicker-trigger"
                      onClick={() => setEndDateIsOpen(true)}
                    >
                      {SelectedEndDate === "" ? (
                        <p className="date-unavailable">
                          {translateText("not_available")}
                        </p>
                      ) : (
                        formatDate(new Date(SelectedEndDate))
                      )}
                    </section>
                    {EndDateIsOpen ? (
                      <div className="datepicker datepicker-end-date">
                        <Datepicker
                          SaveSelectedDate={(EndDate) => saveEndDate(EndDate)}
                          Close={() => setEndDateIsOpen(false)}
                        />
                      </div>
                    ) : null}
                    <p
                      id="date-validation-message"
                      className="date-validation-message"
                    >
                      The End date can't be before the Start date.
                    </p>
                    {SelectedEndDate === "" ? null : (
                      <i
                        className="feather-x-circle"
                        onClick={() => setSelectedEndDate("")}
                      ></i>
                    )}
                  </div>
                  <div className="jpa-publish-switch">
                    <p className="switch-name">{translateText("publish")}</p>
                    <IconSwitch
                      Id="jpa-publish"
                      IsActive={props.JPA.published}
                    />
                  </div>
                </section>
                <div className="vr-line"></div>
                <section className="criteria-wrapper">
                  <h1 className="section-name">
                    {translateText("recom_criteria")}
                    <i className="feather-alert-circle">
                      <p>{translateText("recom_criteria_info")}</p>
                    </i>
                  </h1>
                  <div className="criteria-items edit-criteria">
                    <section className="criteria-row">
                      <p className="row-name">YoE</p>
                      <div className="row-content">
                        <SingleSlider Default={props.JPA.yearsOfExperience} />
                      </div>
                    </section>
                    <section className="criteria-row">
                      <p className="row-name">{translateText("location")}</p>
                      <div className="row-content">
                        <MultiSelect
                          Name={props.JPA.workCity}
                          Options={Locations}
                          Id="location"
                          IsWithId
                          ChangeHandler={() =>
                            removeMultiSelectErrorState("location-select")
                          }
                          SaveSelectedOptions={(Selected) =>
                            saveSelectedLocations(Selected)
                          }
                          PlaceHolder=""
                          PreSelectedOptions={props.JPA.workCity}
                          IsWorkCity={true}
                          ValidationError="Please select at least 1 location."
                          ValidationIsShowAtTop={true}
                        />
                      </div>
                    </section>
                    <section className="criteria-row">
                      <p className="row-name">{translateText("language")}</p>
                      <div className="row-content">
                        <MultiSelect
                          Name="select languages"
                          Options={Languages}
                          Id="language"
                          IsWithId
                          ChangeHandler={() =>
                            removeMultiSelectErrorState("language-select")
                          }
                          SaveSelectedOptions={(Selected) =>
                            saveSelectedLangs(Selected)
                          }
                          PlaceHolder=""
                          PreSelectedOptions={props.JPA.languages}
                          IsWorkCity={false}
                          ValidationError="Please select at least 1 language."
                        />
                      </div>
                    </section>
                    <section className="criteria-row">
                      <p className="row-name">
                        {translateText("top_5_skills")}
                      </p>
                      <div className="row-content">
                        <SearchSelect
                          Label={""}
                          SearchLabel={"search skills"}
                          ToggleSearch={(NameLike) => fetchSkills(NameLike)}
                          Options={Skills}
                          SelectedItems={SelectedSkills}
                          UpdateList={(SelectedList) =>
                            updateSkills(SelectedList)
                          }
                          ClearInput={() => clearSkills()}
                          RemoveSelectedState={() =>
                            removeSkillsSelectedState()
                          }
                          LangData={props.LangData}
                          PreSelectedOptions={PreselectedSkills}
                          ValidationText="Please, select 5 skills"
                        />
                      </div>
                    </section>
                    <section className="criteria-row">
                      <p className="row-name">{translateText("education")}</p>
                      <div className="row-content">
                        <MultiSelect
                          Name="select educations"
                          Options={Educations}
                          Id="education"
                          IsWithId
                          ChangeHandler={() =>
                            removeMultiSelectErrorState("education-select")
                          }
                          SaveSelectedOptions={(Selected) =>
                            saveEducation(Selected)
                          }
                          PlaceHolder=""
                          PreSelectedOptions={handlePreselectedEducations()}
                          IsWorkCity={false}
                          ValidationError="Please select at least 1 education."
                        />
                      </div>
                    </section>
                  </div>
                </section>
              </div>
            )}
          </div>
        </Collapsible>
      </div>
    </div>
  );
};

export default CandidatesHead;
